import { Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AttendeeList, Participant } from '../libs/data-models/src';
import { DBUpdateMessage } from '../libs/ceeyu-common/src';
import { MatTableDataSource } from '@angular/material/table';
export class RegistrationEvent{
    fromdate: Date;
    todate: Date;
    eventstarttime: Date;
    bk: string;
    spname: string;
    spphone: string;
    spemail: string;
    status: number;
    cachestatus: boolean;
    docid: string;
    eventid: string;
    firstexpiration: number;
    title: string;
 }
export interface DeleteRow{
  isarchivemode: boolean;
  templatedata: any;
  mediaid: string;
  filename: string;
  thumbfilename: string;
  filetype?: string;
}
export interface UploadTemplate{
  row: number;
  description: string;
  eventid: string;
  filename: string;
  filetype: string;
  id: string;
  myname: string;
  phone: string;
  size: number;
  thumbfile: string;
  timestamp: number;
  v4param1: string;
  v4param2: string;
  v4param3: string; 
  
}

@Injectable({
  providedIn: 'root'
})

export class DbService {
  public fburl = "https://us-central1-ceeyu-bb46b.cloudfunctions.net/eventlinks";
  delItemsByPhoneMap:Map<String, DeleteRow[]>;
  previewdImageUrlMap: Map<string, any> = new Map<string, any>();
  tableDataArray: UploadTemplate[] = [];
  origTemplatesMap: Map<string, any> = new Map();
  updatedTemplatesMap: Map<string, any> = new Map();
  archivedTemplatesMap: Map<string, any> = new Map();
  uploadStagingMap: Map<string, any> = new Map();
  uploadStagingModified: boolean = false;
  eventInitComplete = false;
  eventid: string;
  bk: string;
  phone: string;
  id: string;
  title: string;
  visitorName: string;
  attendeesAdded = false;
  selectedEvent: RegistrationEvent;
  dataSource: MatTableDataSource<UploadTemplate> = new MatTableDataSource<UploadTemplate>();
  
  constructor(private dbService: NgxIndexedDBService) { }

  getForwardPath(){
    return this.dbService.getByKey('roletype', 'forwardurl');
  }

  setAllRoles(roles){
    roles.forEach(element => {
      this.setRoleType(element.role,element.phone,'');
    });
    
    //return this.dbService.add('allroles', roles);
  }

  getAllRoles(){
    return this.dbService.getAll('roletype');
  }

  setRoleType(roletype, phone,url) : any{
      return this.dbService.add('roletype', { role: roletype, moblephone: phone, forwardurl:url })
  }

  setParticipant(p:Participant) : any{
      return this.dbService.add('persondata', { participantid: p.participantid, role: p.role, lastname: p.lastname, eventid: p.eventid, firstname: p.firstname, mobilephoneprimary: p.mobilephoneprimary, nameToSearch: p.nameToSearch, mobilephonesecondary: p.mobilephonesecondary, barcodes: p.barcodes});
  }

  getAllParticipants() : any{
      return this.dbService.getAll('persondata');
  }

  getCount(){
    return this.dbService.count('roletype');
  }

  clearRoleDB(){
    return this.dbService.clear('roletype');
  }
     
  clearPersonDB(){
    return this.dbService.clear('persondata');
  }

  parsePostReponse(firebaseMessage:DBUpdateMessage, response:Object){
    firebaseMessage.code = response["code"];
      const message = JSON.stringify(response);
      console.log("response:" + message);
      if (firebaseMessage.code === 1){
        firebaseMessage.message = "Thank you. Registration request received."
      }else{
        firebaseMessage.message = "An error occurred in registration request. Please try after some time."
      }
      return firebaseMessage;
  }
 
     /* 
   processAttendeeChanges(mode: string, eventid: string, eventtitle: string, spphone: string, spname: string, attendeelist: AttendeeList,
    message: string, http:HttpClient){
      //mode is addatt
    const temp = {
      spphone: spphone,
      eventtitle: eventtitle,
      spname: spname,
      attlist: attendeelist,
      message: message
    }
    const json = JSON.stringify(temp);
    console.log(json);
      //console.log(registeredevent);
    const postreq = this.sendPost(eventid, json, mode, http);
    return postreq;
  }  
  */

  getUserParams(id: string, http: HttpClient){
    console.log("send invites id:" + JSON.stringify(id));
    let params = new HttpParams();
    params = params.append('link',id);
    const postreq = http.get('https://us-central1-ceeyu-bb46b.cloudfunctions.net/ceeyuapp/resolverouterlink', {
      params
    });
    return postreq;
  }

  /*sendInvites(pl: any, http: HttpClient){
    console.log("send invites pl:" + JSON.stringify(pl));
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      pl: JSON.stringify(pl),
      eventtitle: pl.eventtitle,
      eventid: pl.eventid,
      spname: pl.spname,
      mode: "sendinvites"
    });
    return postreq.toPromise();
  }
*/
    processJoinRequest(eventid: string, 
    spphone: string,
    http:HttpClient){
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      "eventid":eventid,
      "mode": "evtdetails",
      "spphone": spphone
    });
    console.log("calling:" + eventid + spphone);
    return postreq;
  } 


  processGoEventRequest(eventid:string, phone: string, token:string, mode:string,
    http:HttpClient){
    const json = JSON.stringify({
          phone: phone,
          token: token
    });
    console.log(json);
      //console.log(registeredevent);
    const postreq = this.sendPost(eventid,json,mode,http);
    return postreq;
  } 

  uploadedPersons(eventid: string, http:HttpClient){
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      eventid: eventid,
      mode: "chooseperson"
    });
    return postreq;
  }
  
  
   uploadedMedia(eventid: string, http:HttpClient){
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      eventid: eventid,
      mode: "getuploadrows"
    });
    return postreq;
  }
  //

  delExpiredRoutelinks(http:HttpClient){
    const json = JSON.stringify({mode: "deletexpiredroutelinks"});
    const eventid = "unknown";
    const postreq = this.sendPost(eventid,json,"deletexpiredroutelinks",http);
    return postreq;

  }
  processEventChanges(event: RegistrationEvent, bk: string, mode: string,phone: string, visitorName:string,
   http:HttpClient){
    const json = JSON.stringify({deletedevent:event, bk: bk, phone: phone, visitorname: visitorName, reason: 'archive'});
    const eventid = event.docid;
    const postreq = this.sendPost(eventid,json,mode,http);
    return postreq;
} 


  processEventCreate(event: RegistrationEvent, bk: string, mode: string,phone: string, spemail: string, visitorName:string,
   http:HttpClient){
    const json = JSON.stringify({event:event, bk: bk, personid: bk, phone: phone, spemail: spemail,visitorname: visitorName, spname: event.spname, spphone: event.spphone, fromdate: event.fromdate, todate: event.todate, eventstarttime:0, firstexpiration: 0});
    console.log("json is:" + json);
    const eventid = event.docid;
    const postreq = this.sendPost(eventid,json,mode,http);
    return postreq;
  } 

  processEventChangeStatus(eventid: string, status: string, http:HttpClient){
    console.log("eventid:" + eventid);
    console.log("status:" + status);
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      "eventid": eventid,
       "mode": "updateeventstatus",
       "status": status
    });
    return postreq;
  }

  evtDetails(bk: string, eventid: string, http:HttpClient){
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      bk: bk,
      eventid: eventid,
      mode: "evtdetails"
    });
    return postreq.toPromise();
  }

  updatepl(eventid: string, phone: string, http:HttpClient){
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      "eventid": eventid,
      "phone": phone,
      "mode": "updatepl"
    });
    return postreq.toPromise();
  }

  searchEmail(email: string, http:HttpClient){
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      "email": email,
      "mode": "checkemail"
    });
    return postreq.toPromise();
  }

  triageDetails(eventid: string, http:HttpClient){
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      "eventid": eventid,
      "mode": "triagedetails"
    });
    return postreq.toPromise();
  }

  refresh(eventid: string, mode: string, http:HttpClient){
      //refresh from firebase store
      const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      "eventid":eventid,
      "mode": mode + "_refresh"
    });
    return postreq.toPromise();
  }

  signin(phone: string, email: string, http: HttpClient){
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      phone: phone,
      email: email,
      mode: "signin"
    });
    return postreq;
  }

  checkForEvents(cookieverified:boolean, personid: string, myIP: string, http: HttpClient){
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      personid: personid,
      myip:myIP,
      cookieverified: cookieverified,
      mode: "checkevents"
    });
    return postreq.toPromise();
  }

  signup(json: string, http: HttpClient){
    console.log("signup json:" + json);
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      "payload": json,
      "mode": "signup"
    });
    return postreq;
  }

  /*
  2/2/26 start
  */ 

  processAttendeeChanges(mode: string, audience:string,  eventid: string, eventtitle: string, spphone: string, spname: string, attendeelist: AttendeeList,
    message: string, http:HttpClient){
      //mode is addatt
    const temp = {
      spphone: spphone,
      eventtitle: eventtitle,
      spname: spname,
      attlist: attendeelist,
      message: message
    }
    const json = JSON.stringify(temp);
    console.log(json);
      //console.log(registeredevent);
    const postreq = this.sendPostUpdated(eventid, audience, json, mode, http);
    return postreq;
  }

  sendPostUpdated(eventid: string, audience: string, json:string, mode:string, http:HttpClient){
    console.log("eventid:" + eventid);
    console.log("json:" + json);
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
     headers:{
       header: 'Content-Type:application/json'
     }, 
     eventid:eventid,
     audience: audience,
     event: json,
     mode: mode
   });
   return postreq;
}


  /*
  2/2/26 end
  */ 
  sendPost(eventid: string, json:string, mode:string, http:HttpClient){
      console.log("eventid:" + eventid);
      console.log("json:" + json);
      
      //console.log(registeredevent);
      const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      "eventid":eventid,
      "event": json,
      "mode": mode
    });
    return postreq;
  }

  verifyPhone(phone: string, mode: string,http:HttpClient){
    // mode can be "blkchk", "adm" or "regevt"
    //cannot send a + on querystring without encoding..
    const temp = phone;
    let params = new HttpParams();
    const json = JSON.stringify({
      phone: temp,
      mode: mode
    });
    params = params.append('att',json);
    
    const postreq = http.get('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
        params:params
    });
    
    return postreq;
  }

  saveTriage(http:HttpClient, action: string, eventid: string){
    console.log("eventid:" + eventid);
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      "eventid": eventid,
      "mode": "triage",
      "payload": action
    });
    return postreq;
  }

  setRememberme(ip:string) : any{
    const ts = Date.now();
    return this.dbService.add('rememberme', { rememberme: 'yes', ip: ip, timestamp:ts})
  }

  getRememberme() : any{
    return this.dbService.getAll('rememberme');
  }

  setRegisteredevent(name:string) : any{
    const ts = Date.now();
    return this.dbService.add('registeredevents', { name: name, timestamp:ts})
  }

  getRegisteredevents() : any{
    return this.dbService.getAll('registeredevents');
  }

  getEvent(name:string) : any{
    return this.dbService.getByIndex('registeredevents', 'name', name);
  }

  generateImageUrl(image: any, http:HttpClient){
    let uploadfilename = image["uploadfilename"];
    if(uploadfilename== undefined){
      uploadfilename = "";
    }
    const isthumbfile = image["isthumbfile"] == undefined? false:true;
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      uploadfilename: uploadfilename,
      currentrow: image["currentrow"],
      isthumbfile: isthumbfile,
      phone: image["phone"],
      imageid: image["id"],
      curated: image["curated"],
      v4param1: image["v4param1"],
      v4param2: image["v4param2"],
      v4param3: image["v4param3"],
      eventid: image["eventid"],
      mode: "genurl"
    });
    return postreq;
  }

  updateUploadedFiles(eventid: string, deletedMediaidArr: DeleteRow[], phone: String, bucketName: string, http:HttpClient) {
    console.log("eventid:" + eventid);
    const temp = (bucketName+ "_" + eventid).toLowerCase();
    const json = {
      mode: "processdeletedfiles",
      eventid: eventid,
      phone: phone,
      deletedmediaidarr: deletedMediaidArr,
      bucket: temp
    }
    const params = new HttpParams().set('links',  JSON.stringify(json));
    const req = http.get(this.fburl, { params: params });
    return req;
  }

  updateReadlinkTemplate(eventid: string, http: HttpClient){
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      json: Object.fromEntries(this.updatedTemplatesMap.entries()),
      eventid: eventid,
      mode: "updatereadlinktemplate"
    });
    return postreq;
  }
    
  updateUploadStaging(eventid: string, http: HttpClient){
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      json: Object.fromEntries(this.uploadStagingMap.entries()),
      eventid: eventid,
      mode: "updateuploadstaging"
    });
    return postreq;
  }
 
  archiveReadlinkTemplate(eventid: string, http: HttpClient){
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      json: Object.fromEntries(this.archivedTemplatesMap.entries()),
      eventid: eventid,
      mode: "archivereadlinktemplate"
    });
    return postreq;
  }

  populateMapToArr(mapObj: Map<string, any>): any[]{
    let targetObj: any[] = [];
    if(mapObj != undefined){
      const keys = Object.keys(mapObj);
      keys.forEach((key) => {
        let obj = mapObj[key];
        targetObj.push(obj)
      })
    }
    return targetObj;
  }

  updateEventDateTime(eventid: string, eventDateTimeJson: any, http:HttpClient){
    console.log("eventid:" + eventid);
    const postreq = http.post('https://us-central1-ceeyu-bb46b.cloudfunctions.net/registernewevent', {
      headers:{
        header: 'Content-Type:application/json'
      }, 
      "eventid": eventid,
       "mode": "updatedeventdatetime",
       "updatedeventdatetime": eventDateTimeJson
    });
    return postreq;
  }

}
